var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isShow)?_c('div',{staticClass:"mask"},[_c('div',{staticClass:"mask-common",style:({
                width: (_vm.width + "px"),
                height: (_vm.height + "px"),
            })},[_vm._t("default"),_c('div',{staticClass:"quit",on:{"click":_vm.toggle}})],2)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }